var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangleYellow28 = function SvgAlertTriangleYellow28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.834 10.499a1.167 1.167 0 0 1 2.333 0v4.666a1.167 1.167 0 0 1-2.333 0V10.5Zm0 8.166a1.167 1.167 0 1 1 2.334.001 1.167 1.167 0 0 1-2.334 0Zm11.509 2.745c-.267.473-.788.755-1.392.755H5.05c-.605 0-1.125-.282-1.39-.755a1.133 1.133 0 0 1 .019-1.186l8.95-14.838c.544-.903 2.199-.903 2.743 0l8.951 14.838c.31.513.146.965.02 1.186Zm1.979-2.391L17.37 4.18c-.699-1.157-1.959-1.848-3.37-1.848-1.412 0-2.672.69-3.37 1.848l-8.95 14.839a3.469 3.469 0 0 0-.054 3.538C2.302 23.756 3.615 24.5 5.05 24.5H22.95c1.436 0 2.747-.743 3.424-1.942a3.469 3.469 0 0 0-.053-3.538Z",
    fill: "#F3A800"
  })));
};
export default SvgAlertTriangleYellow28;